"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const lucide_vue_next_1 = require("lucide-vue-next");
const axios_1 = __importDefault(require("axios"));
const download_1 = require("@common/utils/download");
const bmk_ui_framework_2 = require("@biomemakers/bmk_ui_framework");
const trans_1 = require("../../../../../../../common/assets/js/tsutils/trans");
let ActionCsv = class ActionCsv extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.url = window.location.href;
        this.segments = this.url.split('/');
        this.projectId = this.segments[this.segments.indexOf('project') + 1];
        this.trialsId = this.segments[this.segments.indexOf('trials') + 1];
        this.isCsvLoading = false;
        this.error = null;
    }
    dismissModal() {
        this.error = null;
    }
    async downloadCsv() {
        this.isCsvLoading = true;
        try {
            const url = `/results/api/project/${this.projectId}/becrop-score/trials/${this.trialsId}/download`;
            axios_1.default.get(url, {
                responseType: 'arraybuffer',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/vnd.ms-excel',
                },
            })
                .then((res) => {
                (0, download_1.downloadExcelWithDynamicName)(res, 'becrop-score-trials.xlsx');
            })
                .catch((error) => {
                const errors = {
                    404: (0, trans_1.trans)('becrop::trialsSummaryPublic.csv.errors.sample_not_found'),
                    403: (0, trans_1.trans)('becrop::trialsSummaryPublic.csv.errors.forbidden'),
                    default: (0, trans_1.trans)('becrop::trialsSummaryPublic.csv.errors.default')
                };
                this.error = errors[error.response.status] || errors.default;
                console.error('Call Error downloading the becrop score for trials', error);
            })
                .finally(() => this.isCsvLoading = false);
        }
        catch (error) {
            console.error('Error downloading the becrop score for trials', error);
        }
        setTimeout(() => { this.isCsvLoading = false; }, 1000);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ActionCsv.prototype, "project", void 0);
ActionCsv = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: { Button: bmk_ui_framework_1.Button, Download: lucide_vue_next_1.Download, Csv: bmk_ui_framework_1.Csv, Modal: bmk_ui_framework_2.Modal }
    })
], ActionCsv);
exports.default = ActionCsv;
